module.exports = __webpack_public_path__ + "img/search_empty.9b6f1bef.png";